const timeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
};

const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0) {
        return `${mins}min`;
    }
    if (mins === 0) {
        return `${hours}h`;
    }
    return `${hours}h ${mins}min`;
};

export const calculateDurationMinutes = (startTime, endTime, isCrossDate) => {
  const start = timeToMinutes(startTime);
  const end = timeToMinutes(endTime);
  if (Number.isNaN(start) || Number.isNaN(end)) return 0;

  let minutes;
  if (isCrossDate) {
    minutes = (24 * 60 - start) + end; // wrap past midnight
  } else {
    minutes = end - start;
  }
  return Math.max(0, minutes);
};

export const calculateDuration = (startTime, endTime, isCrossDate) => {
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);
    let durationMinutes;
    if (isCrossDate) {
        // Add 24 hours (1440 minutes) when crossing midnight
        durationMinutes = (1440 - startMinutes) + endMinutes;
    } else {
        durationMinutes = endMinutes - startMinutes;
    }
    return formatDuration(durationMinutes);
};